import { Injectable } from "@angular/core";
import { SituacaoDocumento } from "@tivic-team/manager-ts/dist/ptc/entities/situacao-documento.entity";
import { CartaoDocumentoDTO } from "app/model/dtos/mob/cartao-documento.dto";
import { HttpGet, HttpResponse, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { environmentv3 } from "src/environments/environmentv3";


@Injectable()
export class SituacaoDocumentoController {
    constructor() {}

    async find(filtros?: IFilter): Promise<Array<SituacaoDocumento>>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'ptc/situacoesdocumento',
                    environment: environment,
                    filter: filtros
                }),
            }),
            new HttpResponse(
                new Array<SituacaoDocumento>()
            )
        );

        return await quark.call();
    }

    async findSolicitacao(filtros?: IFilter): Promise<Array<CartaoDocumentoDTO>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoesdocumentos/solicitacaodocumentos',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<CartaoDocumentoDTO>()
			)
		);
		return await quark.call();
	}

    async findSituacao(filtros?: IFilter): Promise<Array<SituacaoDocumento>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'ptc/situacoesdocumento',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<SituacaoDocumento>()
			)
		);
		return await quark.call();
	}

    async relatorioSituacaoDocumento(filtros?: IFilter):Promise<Blob>{
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoesdocumentos/relatorioprocessos',
					environment: environmentv3,
					filter: filtros
				}),
				responseType: 'Blob'
			}),
            new HttpResponse(
                new Blob()
            )    
        );
        return await quark.call();
	}	
}